import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { Desktop, HardDrives, Plus, PlayCircle, CircleNotch } from '@phosphor-icons/react';

const API = process.env.REACT_APP_BACKEND_URL;
const T = '#14B8A6';

const RDPDashboard = () => {
  const navigate = useNavigate();
  const [vms, setVms] = useState([]);
  const [accounts, setAccounts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([
      axios.get(`${API}/api/rdp/vms`, { withCredentials: true }),
      axios.get(`${API}/api/rdp/accounts`, { withCredentials: true }),
    ]).then(([v, a]) => { setVms(v.data); setAccounts(a.data); }).finally(() => setLoading(false));
  }, []);

  const running = vms.filter(v => v.status === 'running');
  const stat = (label, val) => (
    <div className="bg-card border border-white/10 p-6">
      <div className="text-xs uppercase tracking-widest text-slate-500 font-bold mb-2">{label}</div>
      <div className="text-4xl font-black" style={{ color: T }}>{val}</div>
    </div>
  );

  return (
    <div className="space-y-8 animate-in fade-in slide-in-from-bottom-2 duration-500">
      <div className="flex justify-between items-end">
        <div>
          <h1 className="text-4xl font-black mb-2" style={{ color: T }}>RDP DASHBOARD</h1>
          <p className="text-slate-400 font-mono">Windows Server RDP machines on Azure — end to end.</p>
        </div>
        <button onClick={() => navigate('/rdp/new')} data-testid="rdp-dash-new"
          className="flex items-center gap-2 text-black px-4 py-2 font-bold uppercase tracking-wider" style={{ background: T }}>
          <Plus size={20} /> New Machine
        </button>
      </div>

      {loading ? <CircleNotch size={28} className="animate-spin text-slate-500" /> : (
        <>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {stat('Total Machines', vms.length)}
            {stat('Running', running.length)}
            {stat('Azure Accounts', accounts.length)}
            {stat('Ready Accounts', accounts.filter(a => a.status === 'ready').length)}
          </div>

          <div className="grid md:grid-cols-2 gap-4">
            <div onClick={() => navigate('/rdp/new')} className="group cursor-pointer bg-card border border-white/10 p-6 hover:border-[#14B8A6] transition-colors">
              <Desktop size={36} style={{ color: T }} className="mb-3" />
              <div className="font-bold text-white text-lg">Deploy a Windows machine</div>
              <div className="text-slate-500 text-sm">Pick CPU/RAM, Windows version, users, and go.</div>
            </div>
            <div onClick={() => navigate('/rdp/accounts')} className="group cursor-pointer bg-card border border-white/10 p-6 hover:border-[#14B8A6] transition-colors">
              <HardDrives size={36} style={{ color: T }} className="mb-3" />
              <div className="font-bold text-white text-lg">Manage Azure accounts</div>
              <div className="text-slate-500 text-sm">Onboard subscriptions via service principal.</div>
            </div>
          </div>

          {vms.length > 0 && (
            <div>
              <h3 className="text-sm uppercase tracking-widest text-slate-500 font-bold mb-3">Recent Machines</h3>
              <div className="grid gap-2">
                {vms.slice(0, 5).map(v => (
                  <div key={v.id} onClick={() => navigate('/rdp/machines')} className="cursor-pointer bg-card border border-white/10 p-4 flex items-center justify-between hover:bg-white/5">
                    <div className="flex items-center gap-3"><Desktop size={18} style={{ color: T }} /><span className="font-mono text-white text-sm">{v.name}</span><span className="text-xs text-slate-500">{v.vm_size} · {v.region}</span></div>
                    <span className={`text-xs font-bold ${v.status === 'running' ? 'text-[#14B8A6]' : v.status === 'failed' ? 'text-red-400' : 'text-amber-400'}`}>{v.status}</span>
                  </div>
                ))}
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default RDPDashboard;
